export default __webpack_public_path__ + "static/logo-b4211ce82e4a56e0887a9d303f3f5f16.png";